export default "__VITE_ASSET__DK5N$wrY__"